export default __webpack_public_path__ + "static/media/icon-delivered-car.5a43c3db.svg";